import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_definicion`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_definicion/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_definicion/${id}`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}calculo_definicion`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}calculo_definicion`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}calculo_definicion/${id}`);
  return response;
};

const getDetail = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_detalle/${id}`);
  return response;
};

const getDetailsById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_detalle/by/${id}`);
  return response;
};

const insertDetail = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}calculo_detalle`, payload);
  return response;
};

const updateDetail = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}calculo_detalle`, payload);
  return response;
};

const dropDetail = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}calculo_detalle/${id}`);
  return response;
};

export { getAll, getList, getById, getDetail, getDetailsById, insert, insertDetail, updateDetail, update, drop, dropDetail };
